module.exports = __webpack_public_path__ + "static/media/1pic.aac67a76.png";